import flashMessageMixin from './../../mixins/_flash_messages';
import userProgressMixin from './../../mixins/_user_progress';

/**
 * タスクの一覧を表示するコンポーネント
 */
export default {
    name: 'tasks',
    template: '#tasks_template',
    data() {
        return {
            // タスク完了フラグ一覧
            tasks: {},
        };
    },
    props: {
        // タスクのカテゴリ
        category: {
            type: String,
            default: null,
            require: false
        },
        // タスクキー
        task: {
            type: String,
            default: null,
            require: false
        },
        // 行うべきタスクを優先表示
        show_should_task: {
            type: Boolean,
            default: false,
            required: false,
        },
        // はじめるボタンを外側表示にする
        outside_start_btn: {
            type: Boolean,
            default: false,
            required: false,
        },

    },
    computed: {
        // タスクが存在するか
        hasTasks: function () {
            return Object.keys(this.tasks).length;
        },
        // 一つだけ表示する場合の対象タスク
        showTaskKey: function () {
            if (this.hasTasks) {
                // 指定がある場合
                const key = this.createTaskKey(this.category, this.task);
                if (typeof this.tasks[key] !== 'undefined') {
                    return key;
                }
                // 直近の未完了(カテゴリ指定がある場合)
                if (this.category) {
                    return this.undoneTaskSelect();
                }
                // ランダムの未完了(未指定)
                return this.randomTaskSelect();
            }
            return null;
        },
        // すべてタスクが完了しているか
        isAllDone: function () {
            if (this.undoneTaskSelect()) {
                return false;
            }
            return true;
        },
    },
    mixins: [
        flashMessageMixin,
        userProgressMixin,
    ],
    components: {
        // タスクひと枠を表示するコンポーネント
        'task-wrap': {
            name: 'taskWrap',
            template: '#task_wrap_template',
            props: {
                // 遷移先
                link: {
                    type: String,
                    require: true
                },
                // マニュアルリンク
                help: {
                    type: String,
                    default: null,
                    require: false
                }
            },
        }
    },
    created: async function() {
        await this.setTask();
        // emit
        this.emitUpdateTasks();
        this.emitIsAllDone();
    },
    emits: [
        'update-tasks',
        'is-all-done',
    ],
    methods: {
        // タスクのキーを生成
        createTaskKey: function (category, task) {
            if (category && task) {
                return category + '_' + task;
            }
            return '';
        },
        // タスク一覧をセット
        setTask: async function () {
            let tasks = {};
            let progress = await this.getUserProgress();
            for (const column in progress) {
                // カテゴリ指定があったらそれ以外はスキップ
                if (this.category) {
                    if (this.category !== column) {
                        continue;
                    }
                // 指定がなければopeningをスキップ
                } else {
                    if (column === 'opening') {
                        continue;
                    }
                }
                for (const task in progress[column]) {
                    const key = this.createTaskKey(column, task);
                    const value = progress[column][task];
                    tasks[key] = value;
                }
            }
            this.tasks = tasks;
        },
        // 直近の未完了タスクを取得
        undoneTaskSelect: function () {
            for (const i in this.tasks) {
                if (!this.tasks[i]) {
                    return i;
                }
            }
            return null;
        },
        // ランダムに未完了タスクを取得
        randomTaskSelect: function() {
            let undone = [];
            for (const i in this.tasks) {
                if (!this.tasks[i]) {
                    undone.push(i);
                }
            }
            if (undone.length) {
                const randIndex = Math.floor(Math.random() * undone.length);
                return undone[randIndex];
            }
            return null;
        },
        // 指定タスクのcssクラスを返す
        statusClass: function (category, task) {
            const key = this.createTaskKey(category, task);
            // タスク一覧になければ非表示
            if (typeof this.tasks[key] === 'undefined') {
                return 'd-none';
            }
            // 今すべきタスクを一つ表示、もしくは指定がある場合
            if (this.show_should_task || this.createTaskKey(this.category, this.task)) {
                if (this.showTaskKey === key) {
                    return 'should';
                }
                return 'h-0 opacity-0 overflow-hidden';
            }
            // 以下一覧表示時
            if (this.showTaskKey === key) {
                return 'should';
            }
            if (this.tasks[key]) {
                return 'done';
            }
            return '';
        },

        // -------------------------
        // emit
        // -------------------------

        // task情報を親にも通知する(主にプログレスバー用)
        emitUpdateTasks: function () {
            this.$emit('update-tasks', this.tasks);
        },
        // 全完了しているかを通知
        emitIsAllDone: function () {
            this.$emit('is-all-done', this.isAllDone);
        }
    }
};
